import { useFormContext, useFormField } from '@calendly/form'
import { nanoid } from 'nanoid'
import { useSelector } from 'react-redux'

import { workflowBuilderActionEditSelector } from './selectors'

export const useWorkflowActions = () => {
  const [{ value: workflowActions }] = useFormField({ name: 'workflow_actions' })

  return workflowActions
}

export const useWorkflowActionToEdit = () => useSelector(workflowBuilderActionEditSelector)

const getUpdatedActions = (actions, { uuid, key, configuration }) => {
  if (uuid || key) {
    return actions.map(
      (currentAction) => {
        if ((uuid && currentAction.uuid === uuid) || (key && currentAction.key === key)) {
          return {
            ...currentAction,
            configuration: {
              ...currentAction.configuration,
              ...configuration
            }
          }
        }
        return currentAction
      }
    )
  }

  return [
    ...actions,
    {
      configuration,
      key: nanoid(5)
    }
  ]
}

const cleanActionsFromAction = (actions, { uuid, key }) => {
  if (uuid) {
    return actions.map(
      (workflowAction) => (
        workflowAction.uuid === uuid ? (
          {
            ...workflowAction,
            _destroy: true
          }
        ) : (
          workflowAction
        )
      )
    )
  }

  return actions.filter(
    (workflowAction) => (workflowAction.key !== key)
  )
}

export const useSubmitWorkflowAction = () => {
  const actions = useWorkflowActions()
  const { setFieldValue, setFieldTouched } = useFormContext()

  return (action) => {
    const updatedActions = getUpdatedActions(actions, action)
    setFieldValue('workflow_actions', updatedActions, true)
    setFieldTouched('workflow_actions', true)
  }
}

export const useRemoveWorkflowActions = () => {
  const actions = useWorkflowActions()
  const { setFieldValue, setFieldTouched } = useFormContext()

  return (action) => {
    const updatedActions = cleanActionsFromAction(actions, action)
    setFieldValue('workflow_actions', updatedActions, true)
    setFieldTouched('workflow_actions', true)
  }
}
